<template>
  <v-dialog
    v-model="dialog"
    width="700px">
    <div class="dialog-container">
      <div
        class="dialog-header">
        <div class="flex-sb-center header-title">
          <span>FTP Files</span>
          <font-awesome-icon
            icon="times"
            class="close"
            @click="onCloseDialog"></font-awesome-icon>
        </div>
      </div>
      <div class="card card-table">
        <el-table
          :data="form.ftp_required_files|| []"
          :header-row-class-name="'tableHeader'"
          style="width: 100%">
          <el-table-column
            label="Document">
            <el-table-column
              label="Documents">
              <template #default="{ row }">
                <div class="flex-align-center">
                  <span>{{row.document}}</span>
                  <span
                    v-if="row.from==2||row.from==1"
                    class="block-circle"
                    :class="{'block-circle__blue':row.from==2}"
                  >{{sys_name(row.from)}}</span>
                </div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="File">
            <template slot-scope="scope">
              <section>
                <span
                  v-if="scope.row.file && scope.row.file.url"
                  class="blue pointer"
                  @click="openFile(scope.row.file.url)"
                >{{ scope.row.file.client_name }}</span>
                <span
                  v-else
                  class="missing">No File</span>
              </section>
            </template>
          </el-table-column>
          <el-table-column
            label="Action"
            width="100"
          >
            <template slot-scope="scope">
              <span class="flex action-list">
                <v-button
                  type="text"
                  class="mg-r-15"
                  @click="handleRebuild(scope.row.type)"
                >Rebuild</v-button>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="dialog-footer flex-sb">
        <div>
          <v-button
            gray
            @click="onCloseDialog">Cancel</v-button>
        </div>
        <div>
          <v-button
            green
            @click="onConfirm">Confirm</v-button>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import {rebuildOrderFtp} from '@/api/policy'

export default {
  name: 'ftp-files-dialog',
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    orderId: {
      type: [String, Number],
      default: ''
    },
    value:{
      type:Boolean,
      default:false
    }
  },
  data(){
    return {
      dialog:false
    }
  },
  watch: {
    value:{
      immediate:true,
      handler(val){
        this.dialog = val
      }
    },
  },
  methods:{
    openFile(url) {
      if (url) {
        window.open(url, '_blank')
      }
    },
    handleRebuild(type){
      let params = {
        file_type:type,
        order_id: this.form.id,
      }
      this.network().rebuildOrderFtp(params)
    },
    onConfirm(){
      this.$emit('input',false)
    },
    onCloseDialog(){
      this.$emit('input',false)
    },
    network() {
      return {
        rebuildOrderFtp: async (params) => {
          const {data} = await rebuildOrderFtp({
            order_id: this.orderId,
            ...params
          })
          const {code} = data
          if(code === 1000){
            this.$message({
              type: 'success',
              message: data.message_language,
            })
          }
          this.$emit('input',false)
        },
      }
    }
  }
}
</script>

<style scoped lang="scss">
.dialog-container {
  padding: 15px;

  .missing {
    color: #91939a;
    font-size: 12px;
    font-style: italic;
  }

  .danger {
    color: #f56c6d;
  }

  .dialog-header {
    color: #616266;
    margin-bottom: 30px;

    .flex-sb-center {
      padding: 15px;
      margin: -14px;
      background: #F6F8FA;

      span {
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        color: #1B1F23;
      }
    }
  }

  .btn-list {
    display: flex;
    flex-direction: column;
    align-items: center;

    .el-button {
      display: block;
      margin: 0 auto 10px auto !important;
    }
  }

  .dialog-footer {
    padding-top: 15px;
  }

  .card {
    // margin-bottom: 20px;
    padding: 15px;
    border-radius: 6px;

    &.card-table {
      padding: 0 !important;

      .header {
        background: #F6F8FA;
        border-radius: 6px 6px 0 0;
        border: 1px solid #D1D5DA;
        padding: 15px 13px;

        &__none_table {
          border-radius: 6px;
        }

        .form-item {
          margin-bottom: 0 !important;
          padding-bottom: 0px !important;
        }

        .edit-span {
          font-family: Inter;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 20px;
          color: #0366D6;
          cursor: pointer;
        }
      }

      .span-time {
        font-family: Inter;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
        color: #6A737D;
      }

      .el-table {
        ::v-deep .tableHeader {
          display: none;
        }

        border: 1px solid #D1D5DA;
        border-radius:6px;

        ::v-deep td {
          border-bottom: 1px solid #D1D5DA;
          border-right: 0px !important;
          padding: 5px 0 !important;

          .cell {
            padding-left: 15px;
          }
        }

        ::v-deep tr {
          &:last-child {
            td {
              border-bottom: 0;
            }
          }
        }
      }
    }
  }
}

</style>
